import { AlertMessage } from './alert-message.class';

export class AlertError extends AlertMessage {
  readonly icon: string = 'hexagon-exclamation';
  readonly type: string = 'error';

  constructor(code: string, title: string, message: string) {
    super(code, title, message);
  }
}
